import { useGenericCart } from '@contexts/GenericCartContext/GenericCartContext';
import { showToast } from '@design-system';
import { FavoriteOrder, OrderProduct, useGetWorksiteInfoQuery } from '@services';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useOrderItem = ({
    isFavorite,
    customProducts,
    products,
    type,
    id_worksite
}: {
    customProducts?: Pick<FavoriteOrder, 'products'>;
    isFavorite?: boolean;
    products: OrderProduct[];
    type: 'epi' | 'appro';
    id_worksite: string;
}) => {
    const navigate = useNavigate();
    const [toggled, setToggled] = useState<boolean>(false);
    const productsRef = useRef<HTMLDivElement>(null);

    const { addItem, clearCart } = useGenericCart({ type });

    const productsToDisplay = isFavorite && customProducts?.products ? customProducts.products : products;

    const { data: worksiteInfo } = useGetWorksiteInfoQuery(id_worksite, {
        skip: !id_worksite
    });

    const handleReorder = () => {
        clearCart();
        productsToDisplay.forEach((product) => {
            addItem({
                id: product.id,
                quantity: Number(product.quantity),
                label: product.label,
                packing_unit: product.packing_unit,
                image: product.image
            });
        });
        showToast({
            message: 'Panier restauré',
            type: 'success'
        });
        if (type === 'epi') {
            navigate('/sante-securite/epi/cart');
        } else {
            navigate('/mes-chantiers/approvisionnement/cart');
        }
    };

    useEffect(() => {
        if (productsRef.current) {
            productsRef.current.style.maxHeight = toggled ? `${productsRef.current.scrollHeight}px` : '0';
        }
    }, [toggled, products]);

    return {
        navigate,
        toggled,
        setToggled,
        productsRef,
        productsToDisplay,
        handleReorder,
        worksiteInfo
    };
};
